import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Solo oculta la UI: los datos los protegen RLS y las funciones rpc en Supabase.
const AdminRoute = ({ children }) => {
  const { usuario, esAdmin, cargando } = useAuth();

  if (cargando) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        fontSize: '20px',
        color: '#3d3c44'
      }}>
        Cargando...
      </div>
    );
  }

  if (!usuario) return <Navigate to="/login" replace />;
  return esAdmin ? children : <Navigate to="/" replace />;
};

export default AdminRoute;
